<!-- 开题评审小组评审记录表 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 35.35">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="26.75" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="26.75" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M30.8,14.43V2.58A1.75,1.75,0,0,0,29.05.83H6.75A1.75,1.75,0,0,0,5,2.58V26a1.75,1.75,0,0,0,1.75,1.75H19.3"
        />
        <line class="cls-3" x1="10.27" y1="18.62" x2="19.55" y2="18.62" />
        <line class="cls-3" x1="10.27" y1="22.56" x2="19.55" y2="22.56" />
        <path
          class="cls-3"
          d="M14.93,14.82c.08.1,0,.26-.16.26l-1.65.05-2,.06s0,0,0,0l.55-1.89.46-1.59c0-.13.21-.19.29-.09"
        />
        <line class="cls-3" x1="19.57" y1="5.78" x2="22.2" y2="9.16" />
        <rect
          class="cls-3"
          x="12.34"
          y="6.82"
          width="12.94"
          height="4.71"
          rx="0.84"
          transform="translate(-1.67 13.46) rotate(-37.82)"
        />
        <path
          class="cls-3"
          d="M24.19,19.9a2.32,2.32,0,0,1,2.32-2.32,2.25,2.25,0,0,1,1.28.39,2.32,2.32,0,0,1-1.29,4.25,2.42,2.42,0,0,1-.54-.07,2.32,2.32,0,0,1-1.77-2.25Z"
        />
        <ellipse class="cls-4" cx="23.96" cy="24.47" rx="0.74" ry="0.74" />
        <path
          class="cls-3"
          d="M26,24a4.36,4.36,0,0,1,.51,0,4.54,4.54,0,0,1,2.32.63,3.62,3.62,0,0,1,1.87,3.1"
        />
        <path class="cls-3" d="M22.31,27.68h0a3.36,3.36,0,0,1,.37-1.54" />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 35.27">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="26.67" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="26.67" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M30.8,14.35V2.5A1.75,1.75,0,0,0,29.05.75H6.75A1.75,1.75,0,0,0,5,2.5V25.92a1.75,1.75,0,0,0,1.75,1.75H19.3"
        />
        <line class="cls-3" x1="10.27" y1="18.54" x2="19.55" y2="18.54" />
        <line class="cls-3" x1="10.27" y1="22.48" x2="19.55" y2="22.48" />
        <path
          class="cls-3"
          d="M14.93,14.74c.08.1,0,.25-.16.26l-1.65.05-2,.06s0,0,0,0l.55-1.89.46-1.59c0-.13.21-.19.29-.09"
        />
        <line class="cls-3" x1="19.57" y1="5.7" x2="22.2" y2="9.08" />
        <rect
          class="cls-3"
          x="12.34"
          y="6.74"
          width="12.94"
          height="4.71"
          rx="0.84"
          transform="translate(-1.62 13.44) rotate(-37.82)"
        />
        <path
          class="cls-3"
          d="M24.19,19.82a2.32,2.32,0,1,1,2.31,2.32,2.42,2.42,0,0,1-.54-.07,2.32,2.32,0,0,1-1.77-2.25Z"
        />
        <ellipse class="cls-4" cx="23.96" cy="24.39" rx="0.74" ry="0.74" />
        <path
          class="cls-3"
          d="M26,23.9a4.36,4.36,0,0,1,.51,0,4.54,4.54,0,0,1,2.32.63,3.62,3.62,0,0,1,1.87,3.1"
        />
        <path class="cls-3" d="M22.31,27.6h0a3.36,3.36,0,0,1,.37-1.54" />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.2 35.59">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="26.67" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="26.67" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M30.8,14.35V2.5A1.75,1.75,0,0,0,29.05.75H6.75A1.75,1.75,0,0,0,5,2.5V25.92a1.75,1.75,0,0,0,1.75,1.75H19.3"
        />
        <line class="cls-3" x1="10.27" y1="18.54" x2="19.55" y2="18.54" />
        <line class="cls-3" x1="10.27" y1="22.48" x2="19.55" y2="22.48" />
        <path
          class="cls-3"
          d="M14.93,14.74c.08.1,0,.25-.16.26l-1.65.05-2,.06s0,0,0,0l.55-1.89.46-1.59c0-.13.21-.19.29-.09"
        />
        <line class="cls-3" x1="19.57" y1="5.7" x2="22.2" y2="9.08" />
        <rect
          class="cls-3"
          x="12.34"
          y="6.74"
          width="12.94"
          height="4.71"
          rx="0.84"
          transform="translate(-1.62 13.44) rotate(-37.82)"
        />
        <path
          class="cls-3"
          d="M24.19,19.82a2.32,2.32,0,1,1,2.31,2.32,2.42,2.42,0,0,1-.54-.07,2.32,2.32,0,0,1-1.77-2.25Z"
        />
        <ellipse class="cls-4" cx="23.96" cy="24.39" rx="0.74" ry="0.74" />
        <path
          class="cls-3"
          d="M26,23.9a4.36,4.36,0,0,1,.51,0,4.54,4.54,0,0,1,2.32.63,3.62,3.62,0,0,1,1.87,3.1"
        />
        <path class="cls-3" d="M22.31,27.6h0a3.36,3.36,0,0,1,.37-1.54" />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3 {
      fill: none;
      stroke: #9a9b9b;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.66px;
    }
    .cls-4 {
      fill: #9a9b9b;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: none;
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 1.5px;
    }
    .cls-4 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3,
    .cls-4,
    .cls-5,
    .cls-6,
    .cls-7,
    .cls-9 {
      fill: none;
      stroke-miterlimit: 10;
    }
    .cls-3,
    .cls-4,
    .cls-5,
    .cls-6 {
      stroke: #27aa8e;
    }
    .cls-3,
    .cls-4,
    .cls-5,
    .cls-6,
    .cls-9 {
      stroke-linecap: round;
    }
    .cls-3 {
      stroke-width: 2.13px;
    }
    .cls-4 {
      stroke-width: 1.79px;
    }
    .cls-5 {
      stroke-width: 1.43px;
    }
    .cls-6 {
      stroke-width: 1.57px;
    }
    .cls-7,
    .cls-9 {
      stroke: #2eac90;
    }
    .cls-7 {
      stroke-width: 1.3px;
    }
    .cls-8 {
      fill: #2eac90;
    }
    .cls-9 {
      stroke-width: 1.41px;
    }
  }
</style>
